import { render } from "./whatCanWeDo.vue?vue&type=template&id=7fa75250&scoped=true"
import script from "./whatCanWeDo.vue?vue&type=script&lang=js"
export * from "./whatCanWeDo.vue?vue&type=script&lang=js"

import "./whatCanWeDo.vue?vue&type=style&index=0&id=7fa75250&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa75250"]])

export default __exports__